export default __webpack_public_path__ + "static/media/syringe.16b4373c.svg";